define([
    'text!product-detail/component/swiper-products.html',
    // 'common/api',
    'jquery',
    '../../../../vendor/swiper/swiper-bundle.min.js',

    'css!vendor/swiper/swiper-bundle.min.css',
    'css!product-detail/component/swiper-products.css'

], function(
    tpl,
    // Api,
    $,
    Swiper
){
    return {
        template: tpl,
        data: function(){
            return {
                isPC: true,
                thePage: 0,
            };
        },
        // 这里是传入的数据
        props: {
            SlickImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            },
            SwiperImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            SwiperType: String
        },
        methods: {
            pcIs: function(){
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                }else {
                    obj.isPC = true;
                }
            },
            init: function () {
                var obj = this;
                if(obj.SwiperType=='products'){
                    obj.videoSwiper = new Swiper('#swiper-products',{
                        slidesPerView: 'auto',
                        spaceBetween: 30,
                        lazyLoading : true,
                        observer: true,
                        on: {
                            slideChangeTransitionEnd: function () {
                                obj.thePage = this.activeIndex;
                            }
                        }
                    });
                    // obj.$set(obj.thePage,obj.thePage);
                }
                // console.log(obj.videoSwiper);
            },
            toPage: function(index){
                var obj = this;
                if(index==1){
                    if(parseInt(obj.thePage)<obj.SwiperImage.length){
                        obj.thePage+=1;
                    }
                }else {
                    if(parseInt(obj.thePage)>0){
                        obj.thePage-=1;
                    }
                }
                obj.videoSwiper.slideTo(obj.thePage);
            }
        },
        watch: {
            SwiperImage: function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
            this.pcIs();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/swiper-products.js
// module id = 126
// module chunks = 0